<template>
    <div class="course" id="course">
      <!-- 我的课程 -->
      <div class="screen">
        <div style="width: 1rem;height: 100%;float: left;"> </div>
        <div class="left">
          <div :class="(all ? 'now' : 'now checked')" @click="changeAll(0);">最近学习</div>
          <div class="line"></div>
          <div :class="(all ? 'now checked' : 'now')" @click="changeAll(1);">全部课程</div>
        </div>
        <div class="right" v-if="all">
          <div :class="(screened == index ? 'list check' : 'list')" v-for="(item,index) in tab" :key='index' @click="changeTab(index);">{{item.name}}</div>
        </div>
      </div>
      <div class="content">
        <div class="mine" v-if="!all">
          <div class="list" v-for="(item,index) in list" :key="index">
            <div class="logo">
              <img :src="item.imageUrl" alt="">
            </div>
            <div class="intro">
              <div class="title" @click="toDetail(item.courseId);">{{item.courseName}}</div>
              <div class="tags">
                <div class="tag">{{item.tagName}}</div>
                <span class="lesson_status" v-if="item.courseType == 1">
                  <img v-if="item.status <= 1" src="../../assets/images/lesson_status_none.png" alt="">
                  <img v-if="item.status == 2" src="../../assets/images/lesson_status_learn.png" alt="">
                  <img v-if="item.status == 3" src="../../assets/images/lesson_status_over.png" alt="">
                </span>
              </div>
              <div class="detail">
                <div class="left">
                  <p style="margin-bottom: 0.2rem;"><span style="margin-right: 1rem;"> 学时：{{item.period}}</span><span>授课专家：{{item.lecturer}}</span></p>
                  <div class="btn" @click="toDetail(item.courseId);">进入课程{{item.rate}}</div>
                </div>
              </div>
              <div class="point" style="float: left;" v-show="item.courseType == 2">
                <div class="left">
                  <span class="time">直播开始时间：{{(parseInt(item.liveTime)/1000).c_time('yyyy-MM-dd hh:mm')}}</span>
                  <span class="status" v-if="item.liveStatus == 0" style="color: #808080;border-color: #808080;">未开始</span>
                  <span class="status" v-if="item.liveStatus == 1">正在直播</span>
                  <span class="status" v-if="item.liveStatus == 2" style="color: #808080;border-color: #808080;">已结束</span>
                </div>
              </div>
             <div class="point"  v-show="item.courseType == 2">
                <div class="right">
                  <div class="stars">
                    <img :src="(parseFloat(item.rate) > 0 ? require('../../assets/images/lesson_stared.png') : require('../../assets/images/lesson_star.png'))" alt="">
                      <img :src="(parseFloat(item.rate) > 1 ? require('../../assets/images/lesson_stared.png') : require('../../assets/images/lesson_star.png'))" alt="">
                      <img :src="(parseFloat(item.rate) > 2 ? require('../../assets/images/lesson_stared.png') : require('../../assets/images/lesson_star.png'))" alt="">
                      <img :src="(parseFloat(item.rate) > 3 ? require('../../assets/images/lesson_stared.png') : require('../../assets/images/lesson_star.png'))" alt="">
                      <img :src="(parseFloat(item.rate) > 4 ? require('../../assets/images/lesson_stared.png') : require('../../assets/images/lesson_star.png'))" alt="">
                  </div>
                  <span class="text">课程评分：{{item.num || 0}}人评价</span>
                </div>
              </div>
              <div class="step" v-show="item.courseType == 1">
                <span class="num">学习进度 : {{parseFloat(item.ratio) || 0}}%</span>
                <div class="step_bg">
                  <div class="step_center" :style="'width:'+(parseFloat(item.ratio) || 0)+'%;'"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="all" v-if="all">
          <div class="list" v-for="(item,index) in listAll" :key="index" >
            <div>
               <!-- v-if="screened == 0 || (item.status == screened)" -->
              <div class="logo">
                <img :src="item.imageUrl" alt="">
              </div>
              <div class="intro">
                <div class="title" @click="toDetail(item.courseId);">{{item.courseName}}</div>
                <div class="tags">
                  <div class="tag">{{item.tagName}}</div>
                  <span class="lesson_status" v-if="item.courseType == 1">
                    <img v-if="item.status <= 1" src="../../assets/images/lesson_status_none.png" alt="">
                    <img v-if="item.status == 2" src="../../assets/images/lesson_status_learn.png" alt="">
                    <img v-if="item.status == 3" src="../../assets/images/lesson_status_over.png" alt="">
                  </span>
                </div>
                <div class="detail">
                  <div class="left">
                    <p style="margin-bottom: 0.2rem;"><span style="margin-right: 1rem;"> 学时：{{item.period}}</span><span>授课专家：{{item.lecturer}}</span></p>
                    <div class="btn" @click="toDetail(item.courseId);">进入课程</div>
                  </div>
                </div>
                <div class="point" style="float: left;" v-show="item.courseType == 2">
                  <div class="left">
                    <span class="time">直播开始时间：{{(parseInt(item.liveTime)/1000).c_time('yyyy-MM-dd hh:mm')}}</span>
                    <span class="status" v-if="item.liveStatus == 0" style="color: #808080;border-color: #808080;">未开始</span>
                    <span class="status" v-if="item.liveStatus == 1">正在直播</span>
                    <span class="status" v-if="item.liveStatus == 2" style="color: #808080;border-color: #808080;">已结束</span>
                  </div>
                </div>
              <div class="point" v-show="item.courseType == 2">
                  <div class="right">
                    <div class="stars">
                      <img :src="(parseFloat(item.rate) > 0 ? require('../../assets/images/lesson_stared.png') : require('../../assets/images/lesson_star.png'))" alt="">
                      <img :src="(parseFloat(item.rate) > 1 ? require('../../assets/images/lesson_stared.png') : require('../../assets/images/lesson_star.png'))" alt="">
                      <img :src="(parseFloat(item.rate) > 2 ? require('../../assets/images/lesson_stared.png') : require('../../assets/images/lesson_star.png'))" alt="">
                      <img :src="(parseFloat(item.rate) > 3 ? require('../../assets/images/lesson_stared.png') : require('../../assets/images/lesson_star.png'))" alt="">
                      <img :src="(parseFloat(item.rate) > 4 ? require('../../assets/images/lesson_stared.png') : require('../../assets/images/lesson_star.png'))" alt="">
                    </div>
                    <span class="text">课程评分：{{item.num || 0}}人评价</span>
                  </div>
                </div>
                <div class="step" v-show="item.courseType == 1">
                  <span class="num">学习进度 : {{parseFloat(item.ratio)}}%</span>
                  <div class="step_bg">
                    <div class="step_center" :style="'width:'+parseFloat(item.ratio)+'%;'"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="page_box" v-if="allTotal > 0">
          <!-- background="#2b73cc" -->
            <el-pagination
              layout="prev, pager, next"
              @current-change="handleChangeAll"
              :total="allTotal">

            </el-pagination>
          </div>
        </div>
      </div>
      <!-- 二维码 -->
      <div class="footer_right_img" v-show="codeShow">
        <div class="footer_right_img_box">
          <img class="close" src="../../assets/images/eval_close.png" alt="" @click="codeShow = false;">
          <img class="code" src="../../assets/images/scan_code.png" alt="">
        </div>
      </div>
    </div>
</template>

<script>
  export default {
    name: 'course',
    data () {
      return {
        all:true,
        show:true,
        event:{},
        codeShow:true, // 展示二维码
        page:1,
        limit:10,
        list:[],
        listAll:[],
        screened:0,
        allTotal:0,
        recent:0,
        tab:[{name:'全部',checked:true},{name:'进行中',checked:false},{name:'已完成',checked:false}]
      }
    },
    mounted() {
      this.event = JSON.parse(localStorage.getItem('event'));
      console.log(this.enent);
      var obj = {
          eventId:this.event.eventId,
        }
      this.getList(obj);
      var params = {
          eventId:this.event.eventId,
          page:this.page,
          limit:this.limit,
        }
      this.getAll(params);
    },
    methods:{
      changeTab(index){
        this.tab.forEach((v,k)=>{
          if(index == k){
            v.checked = true;
            this.screened = index;
            var params = {
              type:index,
              eventId:this.event.eventId,
              page:this.page,
              limit:this.limit,
            }
            this.getAll(params);
          }else{
            v.checked = false;
          }
        })
      },
      getList(params){
        var _this = this;
        _this.post('/course/course/listTopNew',params,(data)=>{
          console.log(data,'0099');
          _this.list = data.data;
        })
      },
      getAll(params){
        var _this = this;
        _this.post('/course/course/list',params,(data)=>{
          console.log(data,'data-----');
          _this.listAll = data.data.list;
          this.allTotal = data.data.totalCount
        })
      },
      changeAll(index){
        if(index == 0){
          this.all = false;
        }else{
          this.all = true;
        }
      },
      toDetail(id){
        this.$router.push({name:'Detail',query:{id:id}});
      },
      handleChangeAll(value){
        console.log(value,'value')
        var params = {
          eventId:this.event.eventId,
          page:value,
          limit:this.limit,
        }
        this.getAll(params)
      }
    }
  }
</script>
<style scoped>
.screen{
  /* width: 14.5rem; */
  width: 100%;
  height: 0.6rem;
  margin: 0 auto;
  border-bottom: 0.02rem solid #797979;
}
.screen .now{
  width: 1.4rem;
  height: 0.4rem;
  float: left;
  font-size: 0.21rem;
  color: #4b4b4b;
  text-align: center;
  line-height: 0.4rem;
  margin-top: 0.1rem;
  cursor: pointer;
}
.screen .checked{
  color: #fff;
  background-color: #2b73cc;
}
.screen .line{
  width: 0.02rem;
  height: 0.2rem;
  float: left;
  background-color: #414141;
  margin: 0.2rem 0.1rem;
}
.screen .right {
  float: right;
  width: 2.3rem;
  height: 0.6rem;
  margin-right: 0.3rem;
}
.screen .right .list{
  float: left;
  font-size: 0.2rem;
  color: #414141;
  margin-right: 0.2rem;
  height: 0.4rem;
  line-height: 0.6rem;
  cursor: pointer;
  -webkit-user-select:none;
  -moz-user-select:none;
  -ms-user-select:none;
  user-select:none;
}
.screen .right .list.check{
  color: #2b73cc;
}

.content{
  width: 15rem;
  margin: 0 auto;
}
.content .list{
  width: 100%;
  height: 3.6rem;
}
.content .list .logo{
  float: left;
  width: 5.33rem;
  height: 2.92rem;
  margin: 0.3rem 0.36rem 0 0.85rem;
}
.content .list .logo img{
  width: 100%;
  height: 100%;
  float: left;
}
.content .list .intro{
  width: 8.4rem;
  float: left;
}
.content .list .intro .title{
  font-size: 0.33rem;
  color: #181818;
  margin-top: 0.4rem;
  border-left: 0.08rem solid #0073d3;
  padding-left: 0.27rem;
  cursor: pointer;

  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}
.content .list .intro .tags{
  width: 100%;
  height: 0.35rem;
  margin-top: 0.12rem;
  padding-left: 0.27rem;
}

.content .list .intro .tags .lesson_status{
  width: 1.3rem;
  height: 0.33rem;
}
.content .list .intro .tags .lesson_status img{
  width: 1.3rem;
  height: 0.33rem;
  float: left;
  margin-left: 0.16rem;
}
.content .list .intro .tags .tag{
  font-size: 0.2rem;
  color: #8a6935;
  float: left;
  height: 0.35rem;
  line-height: 0.35rem;
  padding: 0 0.24rem;
  background-color: #f7dd67;
  border-radius: 0.18rem;
}

.content .list .intro .detail{
  width: 100%;
  margin-top: 0.3rem;
  padding-left: 0.28rem;
}
.content .list .intro .detail .left{
  width: 100%;
  float: left;
  position: relative;
  display: inline-block;
}
.content .list .intro .detail .left p{
  float: left;
  font-size: 0.25em;
  color: #414141;
  width: 5.8rem;
  height: 0.5rem;
  line-height: 0.5rem;
}
.content .list .intro .detail .left p span{

}
.content .list .intro .detail .btn{
  width: 2rem;
  height: 0.5rem;
  color: #fff;
  background-color: #2b73cc;
  font-size: 0.25rem;
  text-align: center;
  line-height: 0.5rem;
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
}

.point{
  float: right;
  width: 3.73rem;
  height: 0.24rem;
  margin-top: 0.5rem;
}
.point .left{
  float: left;
}
.point .left .time{
  font-size: 0.17rem;
  color: #414141;
  float: left;
  line-height: 0.28rem;
  margin-right: 0.2rem;
}
.point .left .status{
  font-size: 0.17rem;
  color: #ff0000;
  float: left;
  padding: 0.02rem 0.1rem;
  border: 0.01rem solid #ff0000;
}

.point .right{
  float: right;
}
.point .right .text{
  font-size: 0.17rem;
  color: #414141;
  float: right;
  margin-right: 0.19rem;
  line-height: 0.24rem;
}
.point .right .stars{
  float: right;
  height: 0.24rem;
  line-height: 0.24rem;
}
.point .right .stars img{
  float: left;
  width: 0.24rem;
  height: 0.23rem;
  margin-right: 0.06rem;
}

.step{
  float: left;
  width: 4rem;
  height: 0.3rem;
  line-height: 0.3rem;
  margin-top: 0.5rem;
}
.step .num{
  font-size: 0.17rem;
  color: #414141;
  float: left;
}
.step .step_bg{
  width: 2.28rem;
  height: 0.14rem;
  background-color: #c5c5c5;
  border-radius: 0.07rem;
  margin-top: 0.08rem;
  margin-left: 0.16rem;
  float: left;
  position: relative;
}

.step .step_center{
  width: 0;
  height: 100%;
  z-index: 9;
  background-color: #0073d3;
  border-radius: 0.07rem;
  position: absolute;
  left: 0;
}


.selected{
 width: 100%;
 height: 0.4rem;
 line-height: 0.4rem;
 margin-top: 0.1rem;
}
.selected .couse_status{
  float: left;
}
.selected .couse_status select{
  float: left;
  border: none;
  outline: none;
  font-size: 0.21rem;
  color: #4b4b4b;
  height: 0.4rem;
  line-height: 0.4rem;

/*  border: none;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none; */
}
/* .selected .couse_status select::-ms-expand { display: none; } */
.selected .couse_status select option{
  font-size: 0.21rem;
  color: #4b4b4b;
  position: absolute;
  width: 1rem !important;

}
.selected .couse_status .select_title{
  float: left;
  font-size: 0.21rem;
  color: #4b4b4b;
  margin-left: 0.5rem;
}
.page_box{
  text-align: center;
}

.footer{
  width: 100%;
  height: 1.7rem;
  background-color: #2b2b2b;
  /* margin-top: 0.42rem; */
}
.footer .container{
  width: 12rem;
  height: 100%;
  margin: 0 auto;
}
.footer .container .top{
  font-size: 0.14rem;
  line-height: 0.14rem;
  color: #fff;
  padding-top: 0.45rem;
}
.footer .container .topdy{
  font-size: 0.14rem;
  line-height: 0.14rem;
  color: #fff;
  padding-left: 6.55rem;
  padding-top: -0.40rem;
}
.footer .container .topqq{
  font-size: 0.14rem;
  line-height: 0.14rem;
  color: #fff;
  padding-left: 8.55rem;
  padding-top: -0.40rem;
}
.footer .container .cen{
  font-size: 0.14rem;
  line-height: 0.14rem;
  color: #fff;
  margin-top: 0.21rem;
}
.footer .container .bot{
  font-size: 0.14rem;
  line-height: 0.14rem;
  color: #fff;
  margin-top: 0.21rem;
}
.footer_right_img {
  position: fixed;
  right: 30px;
  bottom: 50px;
  z-index: 9;
  width: 200px;
  /* height: 200px; */
}
.footer_right_img_box {
  position: relative;
}
.footer_right_img .close {
  width: 20px;
  position: absolute;
  top: -30px;
  right: 0;
  cursor: pointer;
  /* height: 100%; */
}
.footer_right_img .code {
  width: 100%;
  /* height: 100%; */
}
</style>



// WEBPACK FOOTER //
// src/components/index/Course.vue